export const setTags = tags => ({
    type: 'setTags',
    payload: tags,
})
